import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'dachser-selects-linescape-schedules',
  template: require('./dachser-selects-linescape-schedules.component.html'),
  styles: [require('./../blog.component.scss'), require('./dachser-selects-linescape-schedules.component.scss')]
})
export class DachserSelectsLinescapeSchedulesComponent extends BlogPage {
  title = "Dachser selects Linescape's Sailing Schedules - Linescape";
  description = "Global Logistics Provider Integrates Data Feeds From the World's Leading Schedule Information Provider.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/dachser-selects-linescape-schedules/dachser-selects-linescape-schedules.component.ts